import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import CoPromoterReadOnlyForm from '../components/CoPromoterReadOnlyForm';
import { Card, CardContent } from '../components/ui/card';
import { Sparkles, AlertCircle, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CoPromotePage = () => {
  const { token } = useParams();
  const [bookInfo, setBookInfo] = useState(null);
  const [coPromoter, setCoPromoter] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/co-promote/${token}/client-form`);
        setBookInfo(res.data.book);
        setCoPromoter(res.data.co_promoter);
      } catch (err) {
        setError(err?.response?.data?.detail || 'No se pudo cargar el formulario');
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <Card className="max-w-md w-full">
          <CardContent className="pt-6 text-center space-y-4">
            <AlertCircle className="w-12 h-12 text-red-500 mx-auto" />
            <h2 className="text-xl font-semibold">No se pudo acceder al formulario</h2>
            <p className="text-sm text-muted-foreground">{error}</p>
            <p className="text-xs text-muted-foreground">
              Si crees que es un error, escribe al promotor del libro.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  const recipient = bookInfo?.profile?.recipient_name || '';

  return (
    <div className="min-h-screen bg-gradient-to-b from-background via-amber-50/30 to-background py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-6 text-center">
          <Sparkles className="w-10 h-10 text-amber-500 mx-auto mb-2" />
          <h1 className="text-2xl sm:text-3xl font-semibold mb-1">
            Hola {coPromoter?.name || ''}
          </h1>
          <p className="text-sm text-muted-foreground max-w-lg mx-auto">
            Te han invitado a ayudar a enriquecer el libro biográfico de <strong>{recipient}</strong>.
            Podrás ver lo que el promotor ha escrito y proponerle nuevas aportaciones. Él decidirá qué se incorpora al libro.
          </p>
        </div>

        <CoPromoterReadOnlyForm
          token={token}
          recipientName={recipient}
        />
      </div>
    </div>
  );
};

export default CoPromotePage;
